import PRIMARY_COLORS from '../colors/primary.js';
import PRIMARY_BORDER_RADIUS from '../borderRadius/primary.js';
import PRIMARY_BOX_SHADOWS from '../boxShadows/primary.js';
import TERTIARY_FONTS from '../fonts/tertiary.js';
import { TERTIARY_TYPOGRAPHY } from '../typography/tertiary.js';

var tertiaryTheme = {
  __type: 'tertiary',
  BORDER_RADIUS: PRIMARY_BORDER_RADIUS,
  BOX_SHADOWS: PRIMARY_BOX_SHADOWS,
  COLORS: PRIMARY_COLORS,
  FONTS: TERTIARY_FONTS,
  TYPOGRAPHY: TERTIARY_TYPOGRAPHY
};

export { tertiaryTheme };
